export const isNumeric = (n: any): boolean =>
  !Number.isNaN(parseFloat(n)) && Number.isFinite(Number(n));
